import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { FormUtils } from '@core/utils/form.utils';

@Component({
  selector: 'app-horizontal-form-card',
  templateUrl: './horizontal-form-card.component.html',
  styleUrls: ['./horizontal-form-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalFormCardComponent implements OnDestroy {
  get submitted(): boolean {
    return this._submitted;
  }

  @Input()
  set submitted(value: boolean) {
    this._submitted = value;

    if (value) {
      FormUtils.markAsTouched(this.form);
      this.cdr.detectChanges();
    }
  }

  get form(): UntypedFormGroup {
    return this._form;
  }

  @Input()
  set form(value: UntypedFormGroup) {
    this._form = value;
    this.cdr.detectChanges();

    if (value) {
      this.subscription = this.form.statusChanges.subscribe(() => {
        this.cdr.detectChanges();
      });
    }
  }

  @Input() public icon: string;
  @Input() public title: string;
  @Input() public model: any;
  @Input() public fields: FormlyFieldConfig[];
  @Input() public options: FormlyFormOptions;
  private _submitted: boolean;

  private _form: UntypedFormGroup;
  private subscription: Subscription;

  constructor(private cdr: ChangeDetectorRef) {
  }

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
